import $ from "jquery";
// import CookieConsent from "@alpaga/cookie-consent";
import "./../styles/main.scss";
// require('./woocommerce/Global');
import AOS from "aos";
import Siema from "siema";
require("jquery.scrollto");
require("./CookieConsent");
// require("./helpers/ihavecookies");
$(document).ready(function () {
    $.extend($.scrollTo.defaults, {
        axis: 'y'
    });
    $(".Button.keep").on("click", function (e) {
        e.preventDefault();
        $("#form").toggleClass("open");
    });
    AOS.init({
        disable: 'mobile'
    });
    setTimeout(function () { AOS.refresh(); }, 500);
    // const CookieConsentNode = new CookieConsent({
    //     locale : "en",
    //     cookies: {
    //         'necessary': {
    //             name: "necessary",
    //             disabled: true,
    //             value: true,
    //             title: "Necessary Cookies",
    //             description: "Necessary cookies help make a website usable by enabling basic\
    //             functions like page navigation and access to secure areas of the website. The website cannot\
    //             function properly without these cookies.",
    //             function: function() {},
    //             cookies: [
    //                 {
    //                     name : "CookieConsent",
    //                     provider : "cookieconsent.extension",
    //                     purpose : "Stores the user's cookie consent state for the current domain",
    //                     expiry : "1 year",
    //                     type : "HTTP",
    //                 },
    //             ]
    //         },
    //         analytics: {
    //             name: "analytics",
    //             value: true,
    //             title: "Analytics Cookies",
    //             function: function() {
    //             },
    //             description: "Analytic cookies help website owners to understand how visitors\
    //             interact with websites by collecting and reporting information anonymously.",
    //             cookies: [
    //                 {
    //                     name : "_ga",
    //                     provider : "Google",
    //                     purpose : "Registers a unique ID that is used to generate statistical data on how the visitor uses the website.",
    //                     expiry : "2 years",
    //                     type : "HTTP",
    //                 },
    //                 {
    //                     name : "_gat",
    //                     provider : "Google",
    //                     purpose : "Used by Google Analytics to throttle request rate",
    //                     expiry : "1 day",
    //                     type : "HTTP",
    //                 },
    //                 {
    //                     name : "_gid",
    //                     provider : "Google",
    //                     purpose : "Registers a unique ID that is used to generate statistical data on how the visitor uses the website.",
    //                     expiry : "1 day",
    //                     type : "HTTP",
    //                 }
    //             ]
    //         }
    //     }
    // });
    // CookieConsentNode.init();
    // const viewCookieBannerButton = document.querySelector(".view-cookie-banner");
    // if (viewCookieBannerButton !== void 0) {
    //     viewCookieBannerButton.addEventListener("click", (e) => {
    //         e.preventDefault();
    //         CookieConsentNode.showDetails();
    //     });
    // }
    $("body").on("click", "a[href^='#']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        if ($(node).length) {
            var posY = $(node).offset().top - $("#main-header").height();
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
    $("#content").find(".content").each(function (i, e) {
        var elm = $(e);
        var picture = new Siema({
            selector: elm.find(".siema-picture").get(0),
            duration: 200,
            easing: 'ease-out',
            perPage: 1,
            startIndex: 0,
            draggable: false,
            multipleDrag: false,
            threshold: 20,
            loop: false,
            rtl: false
        });
        var content = new Siema({
            selector: elm.find(".siema-content").get(0),
            duration: 200,
            easing: 'ease-out',
            perPage: 1,
            startIndex: 0,
            draggable: true,
            multipleDrag: true,
            threshold: 20,
            loop: false,
            rtl: false,
            onChange: function () {
                picture.goTo(content.currentSlide);
                elm.find(".navigation").find(".current").removeClass("current");
                elm.find(".navigation > li:eq(" + content.currentSlide + ")").addClass("current");
            }
        });
        elm.find(".navigation").on("click", "a", function (e) {
            content.goTo($(e.currentTarget).parent().index());
        });
    });
});
